import { useEffect, useState } from 'react';
import { message } from 'antd';
import dayjs from 'dayjs';
import { learnerActivitiesReportService } from '../../Services/Reports/LearnerActivitiesService';
import { LearnerActivityReportTypeEnum,SortDirectionEnum, LearnerActivityReportTypeEnumLabel } from 'Common/Constants/Enums/Individual/Reports/LearnerActivityEnum';

export default function useLearnerActivitiesReport() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  // Set default filters
  const [filters, setFilters] = useState({
    ReportType: LearnerActivityReportTypeEnum.ActiveLearners,
    SortBy: SortDirectionEnum.Ascending,
  });

  /**
   * Fetches the report from the API with provided parameters
   * @param {object} params - The parameters for the API call
   */
  const fetchReport = async (params) => {
    setLoading(true);
    try {
      const res = await learnerActivitiesReportService.getReport(params);
      console.log("....................................laerner activity data",res.data);
      setData(res.data.items || []);
      setTotalCount(res.data.totalCount || 0);
    } catch (error) {
      console.error("API Error:", error);
      message.error('Failed to load learner activities');
    } finally {
      setLoading(false);
    }
  };

const downloadReport = async (params) => {
  try {
    message.loading({ content: 'Generating PDF...', key: 'dl' });

    // Add a timeout to prevent hanging
    const timeoutPromise = new Promise((_, reject) => 
      setTimeout(() => reject(new Error('Download timed out')), 60000) // 60 seconds timeout
    );
    
    const res = await Promise.race([
      learnerActivitiesReportService.downloadReport(params),
      timeoutPromise
    ]);

    if (!res.data || res.data.size === 0) {
      throw new Error('Empty response from server');
    }

    // Generate filename directly in frontend using the same pattern as backend
    const applicationName = "CoreIQPro";
    const reportType = LearnerActivityReportTypeEnumLabel[params.ReportType];
      const dateStr = dayjs().format('MMM-DD-YYYY');
    const filename = `${applicationName}-Learner-Activity-Report-${reportType}-${dateStr}.pdf`;

    const blob = new Blob([res.data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 100);

    message.success({ content: 'PDF downloaded', key: 'dl' });
  } catch (error) {
    console.error("Download Error:", error);
    message.error({ content: 'Download failed', key: 'dl' });
  }
};


  // Initial fetch on component mount
  useEffect(() => {
    const params = {
      PageNumber: pageNumber,
      PageSize: pageSize,
      ReportType: filters.ReportType,
      SortBy: filters.SortBy,
    };
    fetchReport(params);
  }, []); // Only fetch on initial mount

  return {
    data,
    loading,
    pageNumber,
    pageSize,
    totalCount,
    filters,
    setFilters,
    setPageNumber,
    setPageSize,
    fetchReport,
    downloadReport,
  };
}